(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("/Users/ayon.ghosh/dev/embed-sdk/node_modules/lodash/merge.js"), require("react"), require("react-dom/server"));
	else if(typeof define === 'function' && define.amd)
		define("lib", ["/Users/ayon.ghosh/dev/embed-sdk/node_modules/lodash/merge.js", "react", "react-dom/server"], factory);
	else if(typeof exports === 'object')
		exports["lib"] = factory(require("/Users/ayon.ghosh/dev/embed-sdk/node_modules/lodash/merge.js"), require("react"), require("react-dom/server"));
	else
		root["lib"] = factory(root["/Users/ayon.ghosh/dev/embed-sdk/node_modules/lodash/merge.js"], root["react"], root["react-dom/server"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_lodash_merge__, __WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_react_dom_server__) {
return 